// src/components/Header.js
import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useData } from "./Cache";
import { useUser } from "../UserContext";
import logo from "../assets/elitlig(2).png";
import "./style.css";

function normalize(str = "") {
  return str
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9 ]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export default function Header() {
  const { leagues, seasons } = useData();
  const { user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { cityName, leagueName, seasonName } = useParams();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen]   = useState(false);

  // Şehirlerin lig listesi
  const citiesWithLeagues = leagues.reduce((acc, L) => {
    const cityKey = normalize(L.city);
    if (!acc[cityKey]) acc[cityKey] = [];
    acc[cityKey].push(L.league_name);
    return acc;
  }, {});

  const currentCityLeagues = cityName
    ? citiesWithLeagues[cityName] || []
    : [];

  // Alt menüyü göstermek için yeterli segment var mı?
  const segments = location.pathname.split("/").filter(Boolean);
  const showSubHeader = segments.length >= 3; // city/league/season

  // Bir lige tıklandığında en güncel sezonuna git
  const handleLeagueClick = (league) => {
    const leagueKey = normalize(league);
    // bu şehre ve lige ait sezonları al
    const leagueSeasons = seasons
      .filter(
        (s) =>
          normalize(s.city) === cityName &&
          normalize(s.league_name) === leagueKey
      )
      // sezon isimlerini “13. Sezon” gibi metinlerden sayıya döküp sırala
      .sort((a, b) =>
        parseFloat(b.season_name) - parseFloat(a.season_name)
      );
    const latest = leagueSeasons[0];
    if (latest) {
      navigate(`/${cityName}/${leagueKey}/${normalize(latest.season_name)}`);
    }
  };

  return (
    <header className="header-container-h">
      {/* Üst bar */}
      <div className="top-header-h">
        <div className="club-logos-h">
          <strong>HEMEN MAÇ AL:</strong> 0507 169 0888
        </div>
        <div className="top-right-buttons-h">
          <div
            className="city-change-container-h"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <button className="city-change-btn-h">Şehir Değiştir</button>
            {isDropdownOpen && (
              <div className="city-dropdown-h">
                {Object.keys(citiesWithLeagues).map((city) => (
                  <a
                    key={city}
                    href={`/${city}`}
                    className="city-item-h"
                  >
                    {city.replace(/-/g, " ").toUpperCase()}
                  </a>
                ))}
              </div>
            )}
          </div>

          {user && ["admin","editor"].includes(user.role) ? (
            <button
              className="old-site-btn-h"
              onClick={() => window.location.href = "/editor"}
            >
              Editör Paneli
            </button>
          ) : (
            <button
              className="old-site-btn-h"
              onClick={() => window.location.href = "https://elitlig.com.tr"}
            >
              Eski Siteye Git
            </button>
          )}
        </div>
      </div>

      {/* Ana nav */}
      <div className="main-header-h">
        <div className="header-logo-h">
          <a href={ cityName ? `/${cityName}` : "/" }>
            <img src={logo} alt="ELİTLİG" />
          </a>
        </div>
        <button
          className="hamburger-menu"
          onClick={() => setIsSidebarOpen(true)}
        >
          ☰
        </button>

        <ul className="nav-links-h">
          <li><a href="/">ELİTLİG</a></li>
          {currentCityLeagues.map((lg) => (
            <li key={lg}>
              <button
                className="link-button"
                onClick={() => handleLeagueClick(lg)}
              >
                {lg.toUpperCase()}
              </button>
            </li>
          ))}
          <li><a href="/iletisim">İLETİŞİM</a></li>
          <li><a href="/kurallar">KURALLAR</a></li>
          <li><a href="/haber-duyuru">HABER & DUYURU</a></li>
        </ul>
      </div>

      {/* Mobil sidebar */}
      <div className={`sidebar-h ${isSidebarOpen ? "open" : ""}`}>
        <button
          className="close-sidebar"
          onClick={() => setIsSidebarOpen(false)}
        >✖</button>
        <div className="header-logo-h">
          <a href="/">
            <img src={logo} alt="ELİTLİG" />
          </a>
        </div>
        <nav className="sidebar-nav">
          <a href="/">ELİTLİG</a>
          {currentCityLeagues.map((lg) => (
            <button
              key={lg}
              className="link-button sidebar-link"
              onClick={() => handleLeagueClick(lg)}
            >
              {lg}
            </button>
          ))}
          <a href="/iletisim">İLETİŞİM</a>
          <a href="/kurallar">KURALLAR</a>
          <a href="/haber-duyuru">HABER & DUYURU</a>
          {user && ["admin","editor"].includes(user.role) ? (
            <a href="/editor">Editör Paneli</a>
          ) : (
            <a href="https://elitlig.com.tr">Eski Siteye Git</a>
          )}
        </nav>
      </div>

      {/* Alt menü: city/league/season/... */}
      {showSubHeader && (
        <div className="sub-header-h">
          <ul className="sub-menu-h">
            <li>
              <a href={`/${cityName}/${leagueName}/${seasonName}/puan-durumu`}>
                Puan Tablosu
              </a>
            </li>
            <li>
              <a href={`/${cityName}/${leagueName}/${seasonName}/fikstur`}>
                Fikstür
              </a>
            </li>
            <li>
              <a href={`/${cityName}/${leagueName}/${seasonName}/sonuclar`}>
                Sonuçlar
              </a>
            </li>
            <li>
              <a href={`/${cityName}/${leagueName}/${seasonName}/oyuncular`}>
                Oyuncular
              </a>
            </li>
            <li>
              <a href={`/${cityName}/${leagueName}/${seasonName}/transferler`}>
                Transferler
              </a>
            </li>
            <li>
              <a href={`/${cityName}/${leagueName}/${seasonName}/cezalar`}>
                Cezalar
              </a>
            </li>
            <li>
              <a href={`/${cityName}/${leagueName}/${seasonName}/odul-kosesi`}>
                Ödül Köşesi
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
